import { MotifCard, MotifCardBody, MotifChip, MotifChipGroup } from '@ey-xd/motif-react';
import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux';

const ConversationOptionSelect = (props: any) => {
    const { content,  enabledToAnswer } = props;
    const dispatch = useDispatch();
    const renderOptions = useCallback(() => {
        const { options } = content;
        return (
            <MotifChipGroup>
                {options?.map((option: any, index: number) => {
                    return (
                        <MotifChip
                            disabled={!enabledToAnswer || option.disabled}
                            onClick={() => {
                                if(!enabledToAnswer || option.disabled) return;
                                dispatch({ type: "CONVERSATION_MESSAGE_SEND", payload: { text: option.value } })
                            }}
                            className="cursor-pointer"
                            key={index}>{option.label}</MotifChip>
                    )
                })}
            </MotifChipGroup>
        )
    }, [enabledToAnswer])
    return (
        <MotifCard className="!w-full">
            <MotifCardBody className="conversation-option-select">
                <p className="text-lg font-bold">
                    {content.title}
                </p>
                <p className="text-md">
                    {content.subtitle}
                </p>
                <hr className='my-4' style={{ opacity: "0.1" }} />
                {renderOptions()}
            </MotifCardBody>
        </MotifCard>
    )
}

export default ConversationOptionSelect